// extracted by mini-css-extract-plugin
module.exports = {"button":"BaseButton_button__3noRL","text":"BaseButton_text__2VWU6","primary":"BaseButton_primary__6ZBHa","secondary":"BaseButton_secondary__iXvoj"};